import React from "react";
//#region types
import { PopperMenuButtonProps } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { Grid, ClickAwayListener, Popper, Paper, IconButton } from "@mui/material";
import { BlurBackdrop, PopMenuEvents } from "components/common";
import CloseIcon from "@mui/icons-material/Close";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const PopperButton: React.FC<PopperMenuButtonProps> = (props) => {
  const { classes, contentOnOpen, button, children, blurBackgroundOnOpen, overrideCloseMenu, onClose } = props;

  return (
    <PopMenuEvents
      allowClickEventPropagation={props.allowClickEventPropagation}
      render={(anchorEl, isOpen, openMenu, closeMenu, isClosing) => {
        const handleClose = () => {
          const closeHandler = () => {
            if (onClose) onClose();
            closeMenu();
          };

          if (overrideCloseMenu) {
            overrideCloseMenu(closeHandler);
          } else {
            closeHandler();
          }
        };

        return (
          <>
            <BlurBackdrop show={blurBackgroundOnOpen && isOpen} />
            <ClickAwayListener
              mouseEvent="onMouseDown"
              onClickAway={() => {
                if (isOpen && !props.blockOutsideClick) handleClose();
              }}
            >
              <Grid
                item
                className={clsx(classes?.root, isOpen ? classes?.menuOpen : "", isClosing ? classes?.menuClosing : "")}
              >
                <button.type
                  {...button.props}
                  onClick={isOpen ? handleClose : openMenu}
                  disabled={button.props.disabled}
                  className={clsx(button.props.className, cssExports.menuButton)}
                >
                  {contentOnOpen && isOpen ? contentOnOpen : button.props.children}
                </button.type>
                <Popper
                  placement={
                    props.menuPlacement === "bottom"
                      ? "bottom-end"
                      : props.menuPlacement === "top"
                      ? "top-end"
                      : props.menuPlacement
                  }
                  disablePortal={props.disablePopperPortal ?? true}
                  modifiers={[
                    {
                      name: "flip",
                      options: {
                        enabled: true,
                      },
                    },
                    {
                      name: "preventOverflow",
                      options: {
                        enabled: true,
                        boundariesElement: "window",
                      },
                    },
                    {
                      name: "arrow",
                      options: {
                        enabled: true,
                      },
                    },
                    {
                      name: "offset",
                      options: {
                        offset:
                          props.popperOffSet ??
                          (props.menuPlacement === "bottom"
                            ? [0, 0]
                            : props.menuPlacement === "top"
                            ? [0, 20]
                            : [0, 5]),
                      },
                    },
                  ]}
                  anchorEl={anchorEl}
                  open={isOpen}
                  className={clsx(cssExports.popoverContainerOuter, cssExports.popperButtonPopoverContainerOuter)}
                >
                  <Paper className={cssExports.popperButtonContentLayout}>
                    <IconButton aria-label="close" className={cssExports.closeButton} onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                    {typeof children === "function" ? children(handleClose) : children}
                  </Paper>
                </Popper>
              </Grid>
            </ClickAwayListener>
          </>
        );
      }}
    />
  );
};

export default PopperButton;
